import React from 'react'
import './style.css'

export default (props) => {
  return (

      <span>


          <div className="row colour-text">
            <div className="col-md-2 col-sm-12">
              <h2 className="l" >L</h2>
              <p className="lp"><strong>Listen</strong> nonjudgmentally and empathically gather</p>
            </div>
            <div className="col-md-2 col-sm-12">
              <h2 className="i">I</h2>
              <p className="ip">Gather <strong>Information</strong>, ask open questions, don't push</p>
            </div>
            <div className="col-md-2 col-sm-12">
              <h2 className="s">S</h2>
              <p className="sp">Assess people's risk of harm, <strong>Self-harm or Suicide</strong></p>
            </div>
            <div className="col-md-2 col-sm-12">
              <h2 className="t">T</h2>
              <p className="tp"><strong>Tell</strong> them useful information about their problem, reassure</p>
            </div>
            <div className="col-md-2 col-sm-12">
              <h2 className="e">E</h2>
              <p className="ep"><strong>Encouraging</strong> self-help and other support strategies</p>
            </div>
            <div className="col-md-2 col-sm-12">
              <h2 className="n">N</h2>
              <p className="np"><strong>Not alone</strong>, follow up and direct to appropriate professional help</p>
            </div>
          </div>


          <div className="container listen-container">
          <div className="panel panel-default">
          <div className="panel-heading heading-listens">Conversation Starters</div>

            <div className="panel-body listen-list">

            <ul style={{'list-style': 'none',"padding-left": "10px"}}><li>
            Can you tell me a bit more about what happened?
            </li><li>
            How were you feeling at the time?
            </li><li>
            How are you feeling about it now?
            </li><li>
            What was going through your mind?
            </li><li>
            Where is this happening?
            </li><li>
            When things are at the worst they have been tell me how you were feeling?
            </li><li>
            Are there any other things stressing you out at the moment?
            </li><li>
            How are things at home?
            </li><li>
            Is there any thing that helps when you are feeling like this?
            </li><li>
            Is there anyone you are close to who you can talk to about this?
            </li><li>
            This is something people often go through; would you like some more
            information about it?
            </li><li>
            Would you like to talk about this again?
            </li>
            <li>
            When you are feeling at your worst do you ever have thoughts about hurting yourself or ending your life?
            </li>
            <li>
            When was the last time you felt like that?
            </li>
            <li>
            What do you so when you have those thoughts?
            </li>
            <li>
            Have you ever acted on them and tried to hurt yourself?
            </li>
            <li>
            Have you been able to talk to someone about your thoughts?
            </li>
            <li>
            Who is most likely to support you when you are feeling low?
            </li>
            <li>
            This sounds really important and something you need help with, shall
            we book an appointment for you to talk to your personal advisor/the
            school counsellor/me again?
          </li></ul>
            </div>
          </div>



          </div>

    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/Listen/index.js